<script>
import {Pie} from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: this.data,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {},
        ...this.options
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions, {plugins: this.plugins});
  },
}
</script>

<style>
</style>